import pdfMake from "pdfmake/build/pdfmake"
import "pdfmake/build/vfs_fonts"

export default pdfMake
